export type ChartToolbarHighlightMode = 'all' | 'dimOthers' | 'hideOthers';

export const defaultChartToolbarHighlightMode: ChartToolbarHighlightMode = 'all';
